import {Component, Input, OnInit} from '@angular/core';
import {QuestionComponent} from '../question.component';
import {QuestionBase} from '../../domain/question.base';

@Component({
  selector: `crds-question-multi-dropdown-value`,
  template: `
    <div *ngIf="optionsPopulated && show">
      <div>
        <hr>
        <label *ngIf="question.label" class="form-label" [attr.for]="question.key">{{question.label}}
          <span *ngIf="question.required"> *</span>
          <crds-form-error *ngIf="isInvalid" [question]="question"
                           [message]="question.errorMessage"></crds-form-error>
        </label>
        <div class="multiple-item" *ngFor="let multiQuestion of multiQuestions; index as i;">
          <div class="row multiple-item-row">
            <div class="col col-7 col-xs-12">
              <div>{{question.dropdownItemLabel || 'Item'}}:</div>
              <select class="form-control"
                      [(ngModel)]="multiQuestion.key"
                      (change)="updateFormValue()">
                <option *ngFor="let opt of originalOptions"
                        [ngStyle]="(isKeyUsed(opt)) ? {'display':'none'} : {'display':'block'}">
                  {{opt.key}}
                </option>
              </select>
            </div>
            <div class="col col-3 col-xs-12">
              <div>{{question.dropdownValueLabel || 'Value'}}:</div>
              <input class="multiple-item-value" [(ngModel)]="multiQuestion.value"
                     (change)="updateFormValue()"
                     [type]="multiQuestion.type || 'text'">
            </div>
            <div class="col col-2">
              <i (click)="deleteQuestion(i)" class="material-icons btn-sm-delete">delete_forever</i>
            </div>
          </div>
        </div>

        <button *ngIf="multiQuestions.length < originalOptions.length" (click)="addQuestion()"
                class="btn-sm-add">
          <i class="material-icons">playlist_add</i>
        </button>

        <!-- QUESTION HINT -->
        <crds-question-hint [question]="question"></crds-question-hint>

        <p *ngIf="alert">
          <ngb-alert [dismissible]="false" type="secondary">
            <i class="material-icons">info</i> {{question.alert[form.get(question.key).value]}}
          </ngb-alert>
        </p>
      </div>
    </div>
    <!--<pre>{{multiQuestions | json}}</pre>-->
    <!--<pre>{{originalOptions | json}}</pre>-->`,
  styles: [
    `
      .btn-sm-add {
        border-radius: 15px;
        width: 30px;
        height: 30px;
        margin-left: 0.25rem;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
        cursor: pointer;
      }
      .btn-sm-add > i {
        padding-top: 0.25rem;
        font-size: 1.2rem;
        color: white;
      }
      .btn-sm-delete {
        margin-top: 1.3rem;
      }
      .multiple-item {
        margin-top: 0.5rem !important;
        margin-bottom: 0.5rem !important;
      }
      .multiple-item-value {
        line-height: 2rem !important;
        width: 100% !important;
      }
      .multiple-item-row {
        background-color: inherit;
        padding: 0;
      }
      .multiple-item-row > .col {
        padding: 0 0.25rem !important;
      }
      hr {
        margin-top: 0.5rem !important;
        margin-bottom: 0.5rem !important;
      }
    `
  ]
})
export class MultiDropdownWithValueQuestionComponent extends QuestionComponent implements OnInit {
  @Input() form;
  @Input() question: QuestionBase<any>;
  multiQuestions: {
    key: string,
    value: any,
    type: string
  }[] = [];

  /**
   * The original options which may need to be used as a base
   * to filter if this question is subscribed to the value of another question.
   */
  originalOptions: any[] = [];

  ngOnInit() {
    this.originalOptions = [...this.question.options];
    this.multiQuestions = this.form.get(this.question.key).value && Array.isArray(this.form.get(this.question.key).value) ?
      this.form.get(this.question.key).value :
      [];
    setTimeout(() => {
      this.updateFormValue();
    });
  }

  updateFormValue() {
    this.form.get(this.question.key).patchValue(this.multiQuestions);
  }

  addQuestion() {
    const questionFilter = (option) => {
      return !this.multiQuestions
        .filter((multiQuestion) => {
          return multiQuestion.key === option.key;
        }).length;
    };

    this.multiQuestions.push(
      {
        key: this.originalOptions.filter(questionFilter)[0].key,
        value: null,
        type: this.originalOptions.filter(questionFilter)[0].type,
      }
    );
    this.updateFormValue();
  }

  isKeyUsed(opt) {
    if (!this.form.get(this.question.key).value) {
      return false;
    }
    return this.form.get(this.question.key).value
      .filter((item) => {
        return item.key === opt.key;
      }).length > 0;
  }

  deleteQuestion(i) {
    this.multiQuestions.splice(i, 1);
    this.updateFormValue();
  }

  get optionsPopulated(): boolean {
    return this.question.options && this.question.options.length > 0;
  }

  get isInvalid() {
    return this.form.get(this.question.key).touched && this.form.get(this.question.key).invalid;
  }

  get show() {
    const showIfQuestionPopulated = this.question.showIf ?
      this.showIf :
      true;
    return (this.question.showIfPopulated !== true || (this.value)) &&
      showIfQuestionPopulated && this.question.show !== false;
  }

  get alert() {
    return this.question.alert && this.question.alert[this.form.get(this.question.key).value];
  }
}
